var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-chart',_vm._g(_vm._b({attrs:{"loading":_vm.loading,"option":_vm.option,"dataset":_vm.chartData}},'my-chart',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }